import type { Schema } from './types'

export const shared: Schema = {
  'editor-enable-layouts': {
    default: false,
  },
  'editor-enable-text-style-sets': {
    default: false,
  },
  'editor-skip-onboarding': {
    default: false,
  },
  'editor-skip-promotions': {
    default: false,
  },
  'work-create-project': {
    default: false,
  },
  'group-card-enable-teacher-hero': {
    default: false,
  },
}
